import Glide from '@glidejs/glide';
import { getElements, ifSelectorExist } from './utils';

function GlideAutoHeight(Glide, Components, Events) {
  const Component = {
    mount() {
      if (!Glide.settings.autoHeight) return;
      Components.Html.track.style.transition = 'height 200ms ease-in-out';
      this.updateTrackHeight();
    },

    updateTrackHeight() {
      if (!Glide.settings.autoHeight) return;

      const activeSlides = Components.Html.slides.filter((slide, index) => {
        return index >= Glide.index && index <= Glide.index - 1 + Glide.settings.perView;
      });

      const newMaxHeight = activeSlides.reduce((maxHeight, slide) => {
        return Math.max(maxHeight, slide.offsetHeight);
      }, 0);

      const glideTrack = Components.Html.track;
      if (newMaxHeight !== glideTrack.offsetHeight) {
        glideTrack.style.height = `${newMaxHeight}px`;
      }
    },
  };

  Events.on('run', () => {
    Component.updateTrackHeight();
  });
  Events.on('update', () => {
    Component.updateTrackHeight();
  });
  Events.on('resize', () => {
    Component.updateTrackHeight();
  });

  return Component;
  
}


export const initSliders = () => {
  const blogPostsSlider = '.prize_glide_slider';
  if (ifSelectorExist(blogPostsSlider)) {
    Array.from(getElements(blogPostsSlider)).forEach((item) => {
      new Glide(item, {
        perView: 3,
        type: 'carousel',
        focusAt: '1',
        startAt: 0,
        gap: 40,
        breakpoints: {
          1024: {
            gap: 0,
            type: 'slider',
            perView: 2,
            autoHeight: true,
            focusAt: '0',
            startAt: 0,
          },
          768: {
            perView: 1,
            gap: 0,
            type: 'slider',
            autoHeight: false,
            focusAt: '0',
            startAt: 0,
          },
        },
      }).mount({
        GlideAutoHeight: GlideAutoHeight,
      });
    });
  }
};
